<template>
    <div>
        <div :value="value">
            <progress :value="value" max="100" style="width: 100%"></progress>
        </div>
    </div>
</template>

<script>
    export default {
        name: "BProgress",
        props: {
            value: Number,
        },
        data(){
            return {
            }
        }
    }
</script>

<style scoped>

</style>